import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';


@Component({
  selector: 'app-save-changes',
  templateUrl: 'save-changes.component.html',
  styleUrls: ['../../../address/address.component.scss'],
})
export class EditOrderSaveChangesComponent implements OnInit {

  ngOnInit() {}

  constructor(
    private activeModal: NgbActiveModal,
    protected router: Router) {}

  closeModal(wantToProceed) {
    this.activeModal.close(wantToProceed);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/orders/edit/save-changes/save-changes.component.ts